//<%@page contentType="text/javascript"%>
/**
 * @author Sam Alston
 * @fileoverview
 * The core package of the MITS JS Toolkit
 * Base for access to all of the MITS JS Toolit
 * Global utilities
 */

/**
 * MITS global namespace
 * @constructor
 */

'use strict';

var MITS = {
    /**
     * The version of this component
     * @final
     */
    Version: '1.0',

    /**
     *  escape dots and other problematic chars in the selector
     */
    jQueryById: function (elementId){
        return jQuery('#' + elementId.replace( /(:|\.|\[|\]|,|=|@|')/g, '\\$1' ));
    },

    /**
     Declares the package of a JS Class
     */
    setPackage: function (packagePath) {
        var packages = packagePath.split('.');
        var previousNode = this;

        for (var i = 1; i < packages.length; i++) {
            var name = packages[i].trim();
            var currentNode;
            if (previousNode[name]) {
                currentNode = previousNode[name];
            } else {
                currentNode = { };
                previousNode[name] = currentNode;
            }
            previousNode = currentNode;
        }

    },

    /**
     * Adds a javascript file to the current page
     * @param {String} libraryPath The path to the remote javascript library
     * @param {Boolean} absolutePath Specifies whether or not the passed libraryPath is an absolute path, or a path relative to the common.js
     * @param {Boolean} bruteForce Whether or not to use the standard \<script\> (true) or the not so standard ajax request
     * @param numTries
     * @member MITS
     */
    include: function (libraryPath, absolutePath, bruteForce, numTries) {

        var url = (absolutePath ? libraryPath : 'scripts/mits/' + libraryPath);

        if (bruteForce || numTries > 3) {
            document.write('<script type="text/javascript" src="' + url + '"></script>\n');
        } else {
            try {

                jQuery.ajax(url, {
                    async: false,
                    dataType:'script',
                    error: function(request, status, error) {
                        console.error('Error loading: ' + url);
                        console.error(error);
                    }
                });
            } catch (e) {
                if(e.message){
                    if (e.message.indexOf('Circular') === 0) {
                        //throw errors about circular dependencies.
                        //These should be noticed during development and testing
                        throw e;
                    }
                    else {
                        numTries = numTries != null ? numTries + 1 : 1;
                        MITS.include(libraryPath, absolutePath, bruteForce, numTries);
                    }
                } else {
                    console.error(e);
                }
            }
        }
    },

    /**
     * Ensure that the package has been loaded
     */
    _loadedFiles: [],
    _filesWaitingToLoad: [],
    require: function (packageName, path) {
        var useAbsolute = true;
        if (path == null) {
            var packageItems = packageName.split('.');
            if (packageItems.length === 1 && packageItems[0] !== 'MITS') { // Check for external library
                packageItems[0] = packageItems[0].toLowerCase();
                packageItems[1] = packageItems[0].toLowerCase();
                path = '../' + packageItems[0].toLowerCase() + '/' + packageItems[0].toLowerCase() + '.js';
            } else {
                console.warn('Blocking load of ' + packageName);
                return;
            }
            useAbsolute = false;
        }

        var found = false;
        for (var i = 0; i < MITS._loadedFiles.length; i++) {
            if (MITS._loadedFiles[i] === path) {
                found = true;
            }
        }

        if (!found) {
            MITS._filesWaitingToLoad.push(path);

            try {
                MITS._checkForCircularDependencies();
                MITS.include(path, useAbsolute);
            } finally {
                MITS._filesWaitingToLoad.pop();
            }

            MITS._loadedFiles.push(path);
        }
    },

    /**
     * Checks to see if the element at the end of the _filesWaitingToLoad
     * array is contained anywhere previously in the array. If so,
     * this means that the file ends up requiring itself before it can be
     * loaded, and an error is thrown showing the circular chain of
     * dependencies.
     */
    _checkForCircularDependencies: function() {
        var lastFile = MITS._filesWaitingToLoad[MITS._filesWaitingToLoad.length - 1];

        for (var i = 0; i < MITS._filesWaitingToLoad.length - 1; i++) {

            if (MITS._filesWaitingToLoad[i] === lastFile) {
                var circularChain = MITS._filesWaitingToLoad.slice(i);
                throw new Error('Circular dependency detected: ' + circularChain.join(' -> '));
            }
        }
    },

    /**
     * Removes the query parameter from the supplied url.
     */
    removeQueryParam: function(sourceURL, keyToRemove) {
        var rtn = sourceURL.split("?")[0],
            param,
            params_arr = [],
            queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
        if (queryString !== "") {
            params_arr = queryString.split("&");
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split("=")[0];
                if (param === keyToRemove) {
                    params_arr.splice(i, 1);
                }
            }
            rtn = rtn + "?" + params_arr.join("&");
        }
        return rtn;
    }
};

MITS.Util = {

    // add this to your elements to prevent enter from submitting forms:  onkeypress="return disableEnterKey(event);"
    // use onkeypress instead of onkeydown.
    disableEnterKey: function(e){
        return !MITS.Util.wasThatTheEnterKey(e);
    },

    wasThatTheEnterKey: function(e){
        var key = MITS.Util._identifyKey(e);
        return (key === 13);
    },

    _identifyKey: function (e) {
        var key;
        if (window.event) {
            key = window.event.keyCode; //IE
        } else {
            key = e.which;
        }
        return key;
    },

    /**
     * Finds the first node with the given tagName, starting from the
     * specified node and traversing up the DOM.
     *
     * @param node The element from which to retrieve the parent node.
     * @param tagName The tag of the parent element to be searched for.
     * @return The requested parent element, or null if no such parent exists
     */
    getParent: function(node, tagName) {
         while (node.parentNode) {
            node = node.parentNode;
            if (node.tagName != null && node.tagName.toUpperCase() === tagName.toUpperCase()) {
                return node;
            }
        }

        return null;
    },

    getElementsByClass: function(searchClass, node, tag) {
        var classElements = [];
        if (node == null) {
            node = document;
        }
        if (tag == null) {
            tag = '*';
        }

        var els = node.getElementsByTagName(tag);
        var elsLen = els.length;
        var pattern = new RegExp('(^|\\s)' + searchClass + '(\\s|$)');
        for (var i = 0, j = 0; i < elsLen; i++) {
            if (pattern.test(els[i].className)) {
                classElements[j] = els[i];
                j++;
            }
        }
        return classElements;
    },

    /**
     * Creates a new version of the initially supplied function, hard-coding all subsequently supplied arguments
     * in the new function.  The intention of this is to replace the currently existing curry functionality that was
     * previously supplied to us by Prototype.
     * See http://www.westhoffswelt.de/blog/2010/10/8/currying-functions-in-javascript-a-generic-approach
     * @param fn
     * @returns {Function}
     */
    curry: function( fn /*, ... */ ) {
        var curryArgs = Array.prototype.slice.call( arguments, 1 );
        return function( /* ... */ ) {
            var newArgs    = Array.prototype.slice.call( arguments, 0 ),
                mergedArgs = curryArgs.concat( newArgs );
            return fn.apply( this, mergedArgs );
        };
    },

    /**
     * Extends the destination object, copying over, and potentially overwriting, all elements from the source object onto the destination object.
     * @param destination
     * @param source
     * @returns {*}
     * This was originally copied from Prototype.
     */
    extend: function (destination, source) {
        for (var property in source) {
            destination[property] = source[property];
        }
        return destination;
    },

    escapeHTML: function (str) {
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
};

/* Settings */

window.iOS = navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad)/) != null;
window.hovered = null;
window.scrolled = false;
window.scrollCurrentX = 0;
window.scrollCurrentY = 0;

/* Constants */
var DEFAULT_LOAD_TIMEOUT = 100;
var DROPDOWN_WINDOW_BUFFER = 10;
var IE_SCROLLBAR_WIDTH = 18;
window.DEFAULT_LOAD_TIMEOUT  = DEFAULT_LOAD_TIMEOUT ;
window.DROPDOWN_WINDOW_BUFFER  = DROPDOWN_WINDOW_BUFFER ;
window.IE_SCROLLBAR_WIDTH  = IE_SCROLLBAR_WIDTH ;

/****************************************************************\
 |    EVENTS                                            |
 \****************************************************************/

// Sets the current scroll location
function setScrollLocation() {
    window.scrollCurrentX = (window.pageXOffset) ? (window.pageXOffset) : (document.documentElement) ? document.documentElement.scrollLeft : document.body.scrollLeft;
    window.scrollCurrentY = (window.pageYOffset) ? (window.pageYOffset) : (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop;
}

jQuery(window).on('scroll', setScrollLocation);
jQuery(window).on('resize', setScrollLocation);


// Sets an object's absolute position
function setRelativePosition(obj, x, y) {
    setRelativeX(obj, x);
    setRelativeY(obj, y);
}

function setRelativeX(obj, x) {
    obj.style.left = (x || 0) + 'px';
}

function setRelativeY(obj, y) {
    obj.style.top = (y || 0) + 'px';
}
window.setScrollLocation = setScrollLocation;
window.setRelativePosition = setRelativePosition;
window.setRelativeX = setRelativeX;
window.setRelativeY = setRelativeY;


/****************************************************************\
 |    APPEARANCE                                        |
 \****************************************************************/

// Unhovers the old row, and hovers the new row
function addHover(item) {
    jQuery(hovered).removeClass('hover');
    jQuery(item).addClass('hover');
    hovered = item;
}

// Tries to hide the given element id
function hide(id) {
    try {
        document.getElementById(id).style.display = 'none';
    } catch (e) {
    }
}

// Sets the title on the main frame to that of the report
function setFrameTitle() {
    if (top !== self) {
        if (document.body && document.body.className !== 'dashboard') { // make sure we're not in the dashboard
            try {
                top.document.title = document.title;
            } catch (e) {
            }
        }
    }
}
window.addHover = addHover;
window.hide = hide;
window.setFrameTitle = setFrameTitle;

jQuery(document).ready(setFrameTitle);

/****************************************************************\
 |    FORM VALIDATION TOOLS                                |
 \****************************************************************/

// Checks to see if a number is a positive integer
function isNumeric(str) {
    var NUMERIC_CHARACTERS = '0123456789';

    for (var i = 0; i < str.length; i++) {
        if (NUMERIC_CHARACTERS.indexOf(str.charAt(i)) === -1) {
            return false;
        }
    }
    return true;
}
window.isNumeric = isNumeric;


/****************************************************************\
 |    PERSISTENCE                                        |
 \****************************************************************/
function saveSetting(settingID, settingValue) {
    setCookieValue(settingID, settingValue);
}

function getSetting(settingID) {
    return getCookieValue(settingID);
}

function setCookieValue(tag, setTagValue) {
    var cookieName = 'mitspjfg';
    var cookieValue = getCookieValue('all');
    var new_cookieValue = '';
    var tag_found = false;
    var tags_exist = false;
    var separated_values = cookieValue.split('/');
    if (cookieValue !== '') {
        tags_exist = true;
        for (var loop = 0; loop < separated_values.length; loop++) {
            var tag_set = separated_values[loop];
            var tag_array = tag_set.split(':');
            var tag_ID = tag_array[0];
            var tag_setting = tag_array[1];
            if (tag_ID === tag) {
                tag_setting = setTagValue;
                tag_found = true;
            }
            if (loop > 0) {
                new_cookieValue = new_cookieValue + '/';
            }
            if (tag_ID !== tag || setTagValue !== '') {
                // Add the tag back in if it's not the one we're looking for or if it is the one we're looking for and it has a value.
                // Leave it out if we're trying to set it to empty.
                new_cookieValue = new_cookieValue + tag_ID + ':' + tag_setting;
            }
        }
    }
    if (tag_found === false) {
        if (tags_exist === true) {
            new_cookieValue = new_cookieValue + '/';
        }
        new_cookieValue = new_cookieValue + tag + ':' + setTagValue;
    }
    var expDate = new Date();
    expDate.setTime(expDate.getTime() + 1000 * 60 * 60 * 24 * 365);
    // set expiration for a year from now
    document.cookie = cookieName + '=' + encodeURIComponent(new_cookieValue) + '; expires=' + expDate.toUTCString() + ';path=/; ';
}

function getCookieValue(tag) {
    var tagValue = '';
    var cookieName = 'mitspjfg';
    if (document.cookie === '') {
        return tagValue;
    }
    var firstChar, lastChar;
    var workCookie = document.cookie;
    firstChar = workCookie.indexOf(cookieName);
    if (firstChar !== -1) { // if you found the cookie
        firstChar += cookieName.length + 1;
        // skip 'name' and '='
        lastChar = workCookie.indexOf(';', firstChar);
        // Find the end of the value string (i.e. the next ';').
        if (lastChar === -1) lastChar = workCookie.length;
        var cookieValue = decodeURIComponent(workCookie.substring(firstChar, lastChar));
        if (tag === 'all') {
            tagValue = cookieValue;
        } else {
            var separated_values = cookieValue.split('/');
            for (var loop = 0; loop < separated_values.length; loop++) {
                var tag_set = separated_values[loop];
                var tag_array = tag_set.split(':');
                var tag_ID = tag_array[0];
                var tag_setting = tag_array[1];
                if (tag_ID === tag) {
                    tagValue = tag_setting;
                }
            }
        }
    }
    return tagValue;
}
window.saveSetting = saveSetting;
window.getSetting = getSetting;
window.setCookieValue = setCookieValue;
window.getCookieValue = getCookieValue;

/****************************************************************\
 |    UTILITY                                                         |
 \****************************************************************/

// Removes leading and trailing white space
String.prototype.trim = function () {
    return this.replace(/^\s+/g, '').replace(/\s+$/g, '');
};

// Replaces all instances of a target string with a replacement string
String.prototype.replaceAll = function (from, to) {
    var str = this;
    //we split and join because the replace function only replaces
    //the first occurrence, and using replace in a loop causes an infinite
    //loop if the "from" string is contained in the "to" string
    return str.split(from).join(to);
};

// Replaces all unsafe HTML entities in a string
String.prototype.htmlDecode = function () {
    var str = this;
    str = str.replaceAll('&', '&amp;')
        .replaceAll('\'', '&#39;')
        .replaceAll('"', '&quot;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');
    return str;
};
module.exports = MITS;


//////////////////
// WEBPACK FOOTER
// ./mits/mits.js
// module id = 3
// module chunks = 0